import _ from 'lodash'
import { Patient } from '@/core/models/patient.model'

export type MergeOverrides = {
  userInfo?: Partial<Patient['userInfo']>
  contactInfo?: Partial<Patient['contactInfo']>
  attendingPhysician?: Partial<Patient['attendingPhysician']>
  email?: string
  notes?: string
  allergy?: string
  background?: string
  vaccins?: string
  treatment?: string
  height?: number
  weight?: number
  secu?: string
  agreement?: string
  pluginId?: string
  netsoinsId?: string
  insured?: string
  insuredRelationship?: string
  insuranceProvider?: string
  primaryInsurance?: string
  secondaryInsurance?: string
  primaryPolicy?: string
  secondaryPolicy?: string
  primaryPharmacy?: string
}

type FieldGroup = {
  title: string
  fields: { key: string; label: string }[]
}

function hasValue(value: unknown): boolean {
  if (typeof value === 'string') return !_.isEmpty(value.trim())
  return value !== undefined && value !== null
}

export function buildMergeOverrides(
  selection: Record<string, 'primary' | 'secondary'>,
  primaryPatient: Patient,
  secondaryPatient: Patient,
  fieldGroups: FieldGroup[]
): MergeOverrides {
  const overrides: MergeOverrides = {}
  const allFields = fieldGroups.map((group) => group.fields).flat()
  allFields.forEach((field) => {
    const key = field.key.split('_').join('.')
    const primaryValue = _.get(primaryPatient, key)
    const secondaryValue = _.get(secondaryPatient, key)
    const hasPrimary = hasValue(primaryValue)
    const hasSecondary = hasValue(secondaryValue)

    const shouldUseSecondary = selection[key] === 'secondary' || (!hasPrimary && hasSecondary)

    if (shouldUseSecondary) {
      if (key === 'userInfo.fullName') {
        const name = _.get(secondaryPatient, 'userInfo.name')
        const surname = _.get(secondaryPatient, 'userInfo.surname')
        if (name) _.set(overrides, 'userInfo.name', name)
        if (surname) _.set(overrides, 'userInfo.surname', surname)
      } else if (key.startsWith('attendingPhysician')) {
        const value = _.get(secondaryPatient, key)
        if (value !== undefined && value !== null) {
          if (!overrides.attendingPhysician) {
            overrides.attendingPhysician = {}
          }
          _.set(overrides, key, value)
        }
      } else {
        const value = _.get(secondaryPatient, key)
        if (value !== undefined && value !== null) _.set(overrides, key, value)
      }
    }
  })

  return overrides
}
